import React, { useEffect, useState } from "react";
import { fetchHcfDetails } from "./api";
import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { showErrorToast } from "@src/appV2/lib/Notifications";

function NetTerms({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "netTerms").then(setDetails).catch(setError);
  }, [hcfId]);

  const handleChange = (data) => {
    if (data && data?.netTerms > 99) {
      showErrorToast("Net terms value should not be greater than 99");
    } else {
      updateFacility({
        ...data,
        facilityId: hcfId,
      }).catch(() => showErrorToast("Unable to update workplace net terms"));
    }
  };

  return (
    <div>
      <Title>Net Terms</Title>
      <ShowError error={error} message="Unable to fetch workplace Net Terms" />
      <p className="content">
        This Workplace has
        <Value name="netTerms" onChange={handleChange} value={details?.netTerms} />
        days from receipt of a Clipboard invoice to pay
      </p>
    </div>
  );
}

export { NetTerms };
